/** DismissibleDocUploadBanner constants */
import { moderateScale } from '../../../../utils/scaleHelpers';

// lineHeight is 18 => three lines of text is 54
export const MAX_BANNER_TEXT_HEIGHT = moderateScale(54);
